import { render, staticRenderFns } from "./NewComment.vue?vue&type=template&id=0ba76214"
import script from "./NewComment.vue?vue&type=script&lang=js"
export * from "./NewComment.vue?vue&type=script&lang=js"
import style0 from "./NewComment.vue?vue&type=style&index=0&id=0ba76214&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports